import { render, staticRenderFns } from "./ReagentReplacementDrawer.vue?vue&type=template&id=10308f02&scoped=true&"
import script from "./ReagentReplacementDrawer.vue?vue&type=script&lang=js&"
export * from "./ReagentReplacementDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ReagentReplacementDrawer.vue?vue&type=style&index=0&id=10308f02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10308f02",
  null
  
)

export default component.exports